import $ from 'jquery';

class HeroVideo {
    init() {
        if ($('.hero-video').length) {
            let video = document.getElementById('hero-video');

            video.addEventListener('loadeddata', (e) => {
                if (video.readyState >= 3) {
                    document.getElementById('hero-loading').classList.add('hidden');
                }
            });
        }
    }
}

export default HeroVideo;

$(() => {
    const heroVideo = new HeroVideo();
    heroVideo.init();
});